var map = {
	"./product.js": "RkF3",
	"./protocol.js": "og/B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5gfZ";


//////////////////
// WEBPACK FOOTER
// ./src/router/product nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = 5gfZ
// module chunks = 225